import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { MenuStore } from '../../layout/components/menu/menu.store';

@Injectable({
    providedIn: 'root',
})
export class HealthCareRealizedWorkRedirectGuardGuard implements CanActivate {
    protected readonly store = inject(MenuStore);
    protected readonly router = inject(Router);

    canActivate(): Promise<boolean> | boolean {
        let redirectPath = 'content/health-care/realized-work/list/performed-procedures'; // Default path
        const first = this.store.healthCareWorkItems()[0];
        if (first) {
            redirectPath = first.routerLink;
        }

        this.router.navigate([redirectPath]);

        return false;
    }
}
